import React from 'react'
import { menu_list } from '../../assets/assets'
import './Exploremenu.css'
function Exploremenu({category,setCategory}) {
  return (
    <div>

    <div className='container py-5'>
    <div className='explore-menu'>
    <h2 className='explore-heading'>Explore our menu here</h2>
    <div className='explore-menu-list'>
        {
            menu_list.map((item,index)=>{
                return(
                    <figure key={index} onClick={()=>category===item.menu_name?setCategory("All"):setCategory(item.menu_name)}>
                        <div className={category===item.menu_name?"active-cat":"explore-menu-item-img"}>
                        <img src={item.menu_image} alt={item.menu_name}/>
                        </div>
                        <figcaption>
                            <h6 className='explore-menu-item-name'>{item.menu_name}</h6>
                        </figcaption>
                    </figure>
                )
            })
        }
    </div>
    </div>
    </div>
    </div>
  )
}

export default Exploremenu